/**
 * Range `[start, end)` of the vertically ordered rectangles that overlap
 * `[top, bottom]`. Two binary searches: O(log n) rectangles are measured.
 */
export function visibleRange(
  count: number,
  rectOf: (index: number) => { top: number; bottom: number },
  top: number,
  bottom: number
): [start: number, end: number] {
  const firstIndex = (from: number, after: (index: number) => boolean) => {
    let low = from;
    let high = count;
    while (low < high) {
      const middle = (low + high) >>> 1;
      if (after(middle)) high = middle;
      else low = middle + 1;
    }
    return low;
  };
  const start = firstIndex(0, index => rectOf(index).bottom >= top);
  return [start, firstIndex(start, index => rectOf(index).top > bottom)];
}
